import { ref, type Ref } from 'vue';

import WelcomePage from '@/views/WelcomePage.vue';
import ValidationPage from '@/views/ValidationPage.vue';
import CheckoutDetailsPage from '@/views/CheckoutDetailsPage.vue';
import ViewBolPage from '@/views/ViewBolPage.vue';

export enum CheckoutFlowStep {
  WelcomePage = 'WelcomePage',
  ValidationPage = 'ValidationPage',
  CheckoutDetailsPage = 'CheckoutDetailsPage',
  ViewBolPage = 'ViewBolPage'
}

const step = ref<CheckoutFlowStep>(CheckoutFlowStep.WelcomePage);
const isStepLoading = ref<boolean>(false);

const stepValidation = ref<Record<CheckoutFlowStep, boolean>>({
  [CheckoutFlowStep.WelcomePage]: true,
  [CheckoutFlowStep.ValidationPage]: false,
  [CheckoutFlowStep.CheckoutDetailsPage]: false,
  [CheckoutFlowStep.ViewBolPage]: false
});

export function useCheckoutFlow() {
  const getCurrentStepComponent = (step: Ref<CheckoutFlowStep>) => {
    switch (step.value) {
      case CheckoutFlowStep.WelcomePage:
        return WelcomePage;
      case CheckoutFlowStep.ValidationPage:
        return ValidationPage;
      case CheckoutFlowStep.CheckoutDetailsPage:
        return CheckoutDetailsPage;
      case CheckoutFlowStep.ViewBolPage:
        return ViewBolPage;
      default:
        return null;
    }
  };

  const setStepValid = (stepName: CheckoutFlowStep, isValid: boolean) => {
    stepValidation.value[stepName] = isValid;
  };

  const isStepValid = (stepName: CheckoutFlowStep) => {
    return stepValidation.value[stepName] || false;
  };

  const setNextStep = (nextStep: CheckoutFlowStep) => {
    step.value = nextStep;
  };

  const setPreviousStep = (previousStep: CheckoutFlowStep) => {
    step.value = previousStep;
  };

  const validateStep = (stepName: CheckoutFlowStep) => {
    return stepValidation.value[stepName];
  };

  const setIsStepLoading = (loading: boolean) => {
    isStepLoading.value = loading;
  };

  return {
    step,
    getCurrentStepComponent,
    validateStep,
    setStepValid,
    isStepValid,
    setIsStepLoading,
    isStepLoading,
    setNextStep,
    setPreviousStep
  };
}
